import axios from 'axios';
import createAdmin from '../../../application/adminUsers';
import currentUser from '../../store/currentUser';
const store = createAdmin(async page => (await axios.get('/api/admin/users', { params: { pageIndex: page } })).data);
store.modules = { currentUser };
export default store;
